'use client'

import { captureTreatmentQuizAttribution } from '@/features/quiz/treatment-quiz-attribution'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'

export default function TreatmentQuizAttributionCapture() {
  const pathname = usePathname()

  useEffect(() => {
    // Query-only quiz navigation preserves UTM parameters and must not revive a
    // pending touch after the first successful quiz-state save clears it.
    captureTreatmentQuizAttribution(localStorage, window.location.search)
  }, [pathname])

  return null
}
